<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg bg-body-secondary">
      <div class="container-fluid">
        <router-link class="navbar-brand" to="/">MyCrew<span v-if="userName">\{{ userName }}</span></router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" v-if="!isAuthenticated" to="/login">Login</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" v-if="!isAuthenticated" to="/register">Register</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" v-if="!isAuthenticated" to="/reset-password">Reset Password</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" v-if="isAuthenticated" to="/account">Account</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-if="isSuperuser" :href="djangoAdminUrl" target="_blank">Django admin</a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" v-if="isOrganisationAdmin" to="/about">About</router-link>
            </li>
            <li class="nav-item">
              <router-link v-if="isAuthenticated" class="nav-link" to="/logout">Logout</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Display alert messages -->
    <div v-if="success" class="alert alert-success mt-3" v-html="success"></div>
    <div v-if="warning" class="alert alert-warning mt-3" v-html="warning"></div>
    <router-view/>
  </div>
</template>

<script>
import {useAuthStore} from './store/auth';
import {DJANGO_ADMIN_URL} from "@/config";
import {ref, watch} from "vue";
import {useRoute} from "vue-router";

export default {
  name: 'App',
  setup() {
    const route = useRoute();
    // const router = userRouter();
    const success = ref(route.query.success || '');
    const warning = ref(route.query.warning || '');

    watch(route, (newRoute) => {
      success.value = newRoute.query.success || '';
      warning.value = newRoute.query.warning || '';
    });

    return {
      success,
      warning,
    };
  },
  computed: {
    isAuthenticated() {
      const authStore = useAuthStore();
      return authStore.isAuthenticated;
    },
    userName() {
      const authStore = useAuthStore();
      return authStore.user ? authStore.user.username : '';
    },
    isSuperuser() {
      const authStore = useAuthStore();
      return authStore.user ? authStore.user.is_superuser : false;
    },
    djangoAdminUrl() {
      return `${DJANGO_ADMIN_URL}/admin`;
    },
    isOrganisationAdmin() {
      // Return true if the user is an admin of one or more organisations
      const authStore = useAuthStore();
      return authStore.user && authStore.user.admin_organisations ? authStore.user.admin_organisations.length > 0 : false;
    },
  },
};
</script>

<style>
nav {
  padding: 10px;
  background-color: #f8f9fa;
}

router-link {
  margin-right: 10px;
  text-decoration: none;
  color: #007bff;
}

router-link:hover {
  text-decoration: underline;
}
</style>